import { StudioLogger } from '@studio/logger/StudioLogger';

import { BROADCAST_LEAVE_MEETING } from '../Types';
import cancelScreenShareRequest from './screenShare/cancelScreenShareRequest';
import cancelPendingRequest from './cancelPendingRequest';
import {
  DIRECTOR_REQUEST_ACCEPTED,
  DIRECTOR_REQUEST_SENT,
  SCREEN_SHARE
} from 'constants/DirectorControls';

const logger = new StudioLogger('meeting');

function leaveMeeting() {
  return async (dispatch, getState) => {
    const {
      meeting: { meetingSession, client },
      user,
      directorRequestMessages
    } = getState();

    if (
      (directorRequestMessages?.[SCREEN_SHARE] ?? []).includes(
        DIRECTOR_REQUEST_SENT
      )
    ) {
      dispatch(cancelPendingRequest({ requestType: SCREEN_SHARE }));
    } else if (
      (directorRequestMessages?.[SCREEN_SHARE] ?? []).includes(
        DIRECTOR_REQUEST_ACCEPTED
      )
    ) {
      dispatch(cancelScreenShareRequest());
    }

    if (
      meetingSession?.audioVideo &&
      typeof meetingSession?.audioVideo?.stop === 'function'
    ) {
      meetingSession.audioVideo.stop();
    }

    // This will only be available with the Agora flow
    if (client) {
      await client.leave();
    }

    const action = {
      type: BROADCAST_LEAVE_MEETING
    };

    dispatch(action);

    logger.info(`Presenter with id ${user?._id} left the meeting.`, {});
  };
}

export default leaveMeeting;
